import React from 'react';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppConst from "../apis/appconst";
import axios from "axios";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';

function Sales() {
    const navigate = useNavigate();
    
    // Get today's date
    const getTodayDate = () => {
        const d = new Date();
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
    };

    // Format date to DD-MMM-YYYY (e.g., 12-Dec-2025)
    const formatDate = (dateString) => {
        if (!dateString) return '-';
        
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
                           'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();
        
        return `${day}-${month}-${year}`;
    };
// Format Bill Number with leading zeros
const formatBillNo = (billId) => {
    if (!billId) return '-';
    return String(billId).padStart(3, '0');
};
    const [image, setImage] = useState('');
    const [isAdmin, setIsAdmin] = useState(false);
    const [formData, setFormData] = useState({
        l1: [],
        med_bill_type: 'normal',
        page_no: 0,
        alertMsg: '',
        alertMsgTyp: '',
        search_key: '',
        from_date: getTodayDate(),
        to_date: getTodayDate(),
        isAlert: false,
    });

    const [totals, setTotals] = useState({
        totalAmount: 0,
        discountAmount: 0,
        paidAmount: 0,
        dueAmount: 0,
        totalTaxCharges: 0,
    });
    const handlePay = async (bill) => {
        const total = parseFloat(bill.med_bill_final_amt || 0);
        const paid = parseFloat(bill.med_bill_paid || 0);
        const due = parseFloat(bill.med_bill_due || 0);
      
        const { value: payAmount } = await Swal.fire({
          title: 'Pay Amount',
          html: `
            <div style="text-align:left">
              <p><strong>Total Amount:</strong> ₹${total.toFixed(2)}</p>
              <p><strong>Already Paid:</strong> ₹${paid.toFixed(2)}</p>
              <p><strong>Due Amount:</strong> ₹${due.toFixed(2)}</p>
              <hr/>
              <input id="payAmt" type="number" class="swal2-input"
                placeholder="Enter pay amount"
                min="1"
                max="${due}"
                value="${due}" />
            </div>
          `,
          focusConfirm: false,
          showCancelButton: true,
          confirmButtonText: 'Pay Now',
          preConfirm: () => {
            const val = parseFloat(document.getElementById('payAmt').value);
            if (!val || val <= 0 || val > due) {
              Swal.showValidationMessage('Invalid pay amount');
              return false;
            }
            return val;
          }
        });
      
        if (!payAmount) return;
      
        // 🔥 CALL BACKEND
        const fd = new FormData();
        fd.append('med_bill_id', bill.med_bill_id);
        fd.append('pay_amount', payAmount);
      
        try {
          const res = await axios.post(
            AppConst.BASE_URL + AppConst.payMedBillUrl,
            fd,
            { headers: { 'Content-Type': 'multipart/form-data' } }
          );
      
          if (res.data.status) {
            Swal.fire('Success', 'Payment updated', 'success');
            initData(); // 🔁 refresh list
          } else {
            Swal.fire('Error', res.data.message || 'Payment failed', 'error');
          }
        } catch (e) {
          Swal.fire('Error', 'Server error', 'error');
        }
      };
      
    const [ldata, setLdata] = useState(null);
    const [editItem, setEditItem] = useState(null);
    const [showMedicineModal, setShowMedicineModal] = useState(false);
    const [selectedBillMedicines, setSelectedBillMedicines] = useState([]);
    const [selectedBillInfo, setSelectedBillInfo] = useState(null);
    const isAdminUser = () => {
        try {
          const raw = sessionStorage.getItem('ldata');
          if (!raw) return false;
          const user = JSON.parse(raw);
          return String(user?.role_id) === '1';
        } catch (e) {
          return false;
        }
      };
      
    // Check if user can edit (within 24 hours or admin)
    const canEdit = (billDate) => {
        if (isAdmin) return true;
        
        const bill = new Date(billDate);
        const now = new Date();
        const diffInHours = (now - bill) / (1000 * 60 * 60);
        
        return diffInHours <= 24;
    };

    const initData = async () => {
        const storedData = sessionStorage.getItem("ldata");
        const userData = JSON.parse(sessionStorage.getItem("ldata"));
        const roleId = userData?.role_id;
        
        if (roleId === 1 || roleId === "1") {
            setIsAdmin(true);
        } else {
            setIsAdmin(false);
        }

        if (storedData) {
            const parsed = JSON.parse(storedData);
            const fd = new FormData();
            fd.append('page_no', 'none');
            fd.append('search_key', formData.search_key + "");
            fd.append('med_bill_type', 'all');
            fd.append('from_date', formData.from_date ? formData.from_date : "");
            fd.append('to_date', formData.to_date ? formData.to_date : "");

            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.getMedBillListUrl, fd, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
                if (response.data.status) {
                    var records = response.data.records;
                    if (records) {
                        setFormData(prev => ({
                            ...prev,
                            l1: records
                        }));
                    }
                }
            } catch (error) {
                console.error(error);
            }
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleEdit = (item) => {
        if (!canEdit(item.med_bill_date)) {
            Swal.fire({
                icon: 'warning',
                title: 'Cannot Edit',
                text: 'You can only edit sales within 24 hours of creation.',
                confirmButtonColor: '#405189'
            });
            return;
        }

        Swal.fire({
            title: 'Edit Sale?',
            text: `Do you want to edit sale for ${item.med_bill_patient_number}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#405189',
            cancelButtonColor: '#f06548',
            confirmButtonText: 'Yes, Edit',
            cancelButtonText: 'Cancel'
        }).then((result) => {
            if (result.isConfirmed) {
                sessionStorage.setItem("opd_dt", JSON.stringify(item));
                navigate("/pharmacy_sale");
            }
        });
    };

    const delItem = async (item) => {
        if (!isAdmin) {
            Swal.fire({
                icon: 'error',
                title: 'Access Denied',
                text: 'Only administrators can delete sales records.',
                confirmButtonColor: '#405189'
            });
            return;
        }

        const result = await Swal.fire({
            title: 'Delete Sale?',
            html: `Are you sure you want to delete this sale?<br><strong>Patient: ${item.med_bill_patient_number}</strong><br><strong>Amount: ₹${item.med_bill_final_amt}</strong>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#f06548',
            cancelButtonColor: '#405189',
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'Cancel'
        });

        if (result.isConfirmed) {
            const fd = new FormData();
            fd.append('med_bill_id', item.med_bill_id + "");
            try {
                const response = await axios.post(AppConst.BASE_URL + AppConst.delMedBillUrl, fd, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                if (response.data.status) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Deleted!',
                        text: 'Sale record has been deleted.',
                        confirmButtonColor: '#405189',
                        timer: 2000
                    });
                    initData();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Failed to delete sale record.',
                        confirmButtonColor: '#405189'
                    });
                }
            } catch (error) {
                console.error(error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'An error occurred while deleting.',
                    confirmButtonColor: '#405189'
                });
            }
        }
    };

    // Auto-fetch when dates change
    useEffect(() => {
        const timer = setTimeout(() => {
            initData();
        }, 300);
        return () => clearTimeout(timer);
    }, [formData.from_date, formData.to_date]);

    useEffect(() => {
        console.log('Component mounted');
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
            initData();
        }

        return () => {
            console.log('Component unmounted');
        };
    }, []);

    const numberToWords = (num) => {
        if (num === null || num === undefined || isNaN(num)) return '';
    
        // ✅ convert to integer rupees
        num = Math.round(Number(num));
    
        const a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ',
            'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ',
            'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
    
        const b = ['', '', 'twenty ', 'thirty ', 'forty ', 'fifty ',
            'sixty ', 'seventy ', 'eighty ', 'ninety '];
    
        if (num === 0) return 'Zero Only';
    
        if (num.toString().length > 9) return 'Overflow';
    
        const n = ('000000000' + num)
            .slice(-9)
            .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    
        if (!n) return '';
    
        let str = '';
    
        str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + a[n[1][1]]) + 'Crore ' : '';
        str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + a[n[2][1]]) + 'Lakh ' : '';
        str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + a[n[3][1]]) + 'Thousand ' : '';
        str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + a[n[4][1]]) + 'Hundred ' : '';
        str += (n[5] != 0)
            ? ((str !== '') ? 'And ' : '') + (a[Number(n[5])] || b[n[5][0]] + a[n[5][1]])
            : '';
    
        return str.trim()
            .replace(/\s+/g, ' ')
            .replace(/\b\w/g, l => l.toUpperCase()) + ' Only';
    };
    

    const fetchConfigData = async () => {
        try {
            const res = await axios.post(
                `${AppConst.BASE_URL + AppConst.getconfig}?config_type=lab`
            );

            if (res.data.status) {
                const data = res.data;
                setImage(data.header_logo);
            }
        }
        catch (err) {
            console.error("Error fetching config:", err);
        }
    };

    useEffect(() => {
        fetchConfigData()
    }, []);

    const imageUrlToBase64 = async (url) => {
        if (!url) {
            console.error("Image URL is empty or invalid.");
            return null;
        }

        try {
            const response = await fetch(url);
            if (!response.ok) {
                console.error(`Failed to fetch image. Status: ${response.status} ${response.statusText}`);
                return null;
            }

            const blob = await response.blob();

            if (!blob.type.startsWith('image/')) {
                console.error(`The provided URL did not point to an image. It pointed to a file of type: ${blob.type}`);
                return null;
            }

            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error("Error fetching or converting image:", error);
            return null;
        }
    };

    const formatBillDate = (dateStr) => {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        if (isNaN(d)) return dateStr;
    
        const day = String(d.getDate()).padStart(2, '0');
        const monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        const month = monthNames[d.getMonth()];
        const year = d.getFullYear();
    
        return `${day}-${month}-${year}`;
    };
    
    const formatAge = (y = 0, m = 0, d = 0) => {
        const parts = [];
        if (y > 0) parts.push(`${y} Year${y > 1 ? 's' : ''}`);
        if (m > 0) parts.push(`${m} Month${m > 1 ? 's' : ''}`);
        if (d > 0) parts.push(`${d} Day${d > 1 ? 's' : ''}`);
        return parts.length ? parts.join(' ') : '0 Day';
    };
    
    const generateInvoicePdf = async (invoiceData) => {
    
        const doc = new jsPDF("p", "pt", "a4");
        const pageWidth = doc.internal.pageSize.getWidth();
        const margin = 30;
        let y = 40;
    
        // ---------- HEADER IMAGE ----------
        const headerImageBase64 = await imageUrlToBase64(image);
        const headerImageHeight = 80;
    
        if (headerImageBase64) {
            doc.addImage(headerImageBase64, "PNG", 0, 0, pageWidth, headerImageHeight);
        }
    
        y = headerImageHeight + 20;
        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.text("Pharmacy Bill", pageWidth / 2, y, { align: "center" });
        y += 10;
        // ---------- PATIENT BOX ----------
        doc.rect(margin, y, pageWidth - 2 * margin, 80);
    
        let leftX = margin + 10;
        let rightX = pageWidth / 2 + 40;
        let lineY = y + 15;
    
        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        doc.text("Bill To:", leftX, lineY);
    
        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);
    
        doc.text(
            `Patient Name : ${invoiceData.med_bill_patient_number || 'Walk-in Customer'}`,
            leftX,
            (lineY += 15)
        );
    
        const ageText = formatAge(
            invoiceData.med_bill_age_year,
            invoiceData.med_bill_age_month,
            invoiceData.med_bill_age_day
        );
    
        doc.text(`Age : ${ageText}`, leftX, (lineY += 15));
        doc.text(`Mobile : ${invoiceData.med_bill_phone_number || ''}`, leftX, (lineY += 15));
    
        // ✅ DOCTOR NAME FIX
        doc.text(
            `Doctor : ${invoiceData.med_bill_doctor || invoiceData.med_bill_ref_doctor || '-'}`,
            leftX,
            (lineY += 15)
        );
    
        // ---------- RIGHT SIDE ----------
        lineY = y + 15;
    
        const grandTotal = parseFloat(invoiceData.med_bill_final_amt || 0);
        const paid = parseFloat(invoiceData.med_bill_paid || 0);
    
        let paymentStatus = "Not Paid";
        if (paid >= grandTotal) paymentStatus = "Paid";
        else if (paid > 0) paymentStatus = "Partial Paid";
    
        doc.text(`UHID : ${invoiceData.med_bill_ipd_number || ''}`, rightX, lineY);
        doc.text(`Bill No : ${formatBillNo(invoiceData.med_bill_id)}`, rightX, (lineY += 15));
        doc.text(`Bill Date : ${formatBillDate(invoiceData.med_bill_date)}`, rightX, (lineY += 15));
        doc.text(`Payment Status : ${paymentStatus}`, rightX, (lineY += 15));
    
        // ---------- TABLE ----------
        y += 100;
    
        const tableHeaders = [[
            "Sl#", "Product", "Pack", "Qty", "Batch", "Expiry", "HSN", "Discount", "MRP", "Amount"
        ]];
    
        const tableBody = (invoiceData.items || []).map((med, index) => {
            const qty = parseInt(med.med_bill_item_qty || 0);
            const mrp = parseFloat(med.med_bill_item_mrp || 0);
            const discount = parseFloat(med.med_bill_item_discount || 0);
            const total = (mrp - discount) * qty;
    
            return [
                index + 1,
                med.med_bill_item_medicine || '',
                (med.med_bill_item_is_loose == 1 ? "Loose" : "Package"),
                qty,
                med.med_bill_item_batch || '',
                med.med_bill_item_exp || '',
                med.med_bill_item_hsn || '',
                discount.toFixed(2),
                mrp.toFixed(2),
                total.toFixed(2),
            ];
        });
    
        autoTable(doc, {
            startY: y,
            head: tableHeaders,
            body: tableBody,
            theme: "grid",
            styles: { fontSize: 9, cellPadding: 4 },
            headStyles: { fillColor: [220, 220, 220], textColor: 0, fontStyle: "bold" }
        });
    
        // ---------- SUMMARY ----------
        y = doc.lastAutoTable.finalY + 15;
    
        const totalTax = (invoiceData.items || []).reduce(
            (sum, i) => sum + parseFloat(i.med_bill_item_tax_amt || 0),
            0
        );
    
        const subtotal = parseFloat(invoiceData.med_bill_total || 0);
        const discountAll = parseFloat(invoiceData.med_bill_discount_amt || 0);
        const due = parseFloat(invoiceData.med_bill_due || 0);
    
        doc.setFontSize(10);
        doc.text(`Subtotal`, pageWidth - margin - 200, y);
        doc.text(`Rs ${subtotal.toFixed(2)}`, pageWidth - margin, y, { align: "right" });
    
        doc.text(`Total GST`, pageWidth - margin - 200, (y += 15));
        doc.text(`Rs ${totalTax.toFixed(2)}`, pageWidth - margin, y, { align: "right" });
    
        doc.text(`Discount`, pageWidth - margin - 200, (y += 15));
        doc.text(`Rs ${discountAll.toFixed(2)}`, pageWidth - margin, y, { align: "right" });
    
        doc.setFont("helvetica", "bold");
        doc.text(`Grand Total`, pageWidth - margin - 200, (y += 20));
        doc.text(`Rs ${grandTotal.toFixed(2)}`, pageWidth - margin, y, { align: "right" });
    
        doc.setFont("helvetica", "normal");
        doc.text(`Paid`, pageWidth - margin - 200, (y += 15));
        doc.text(`Rs ${paid.toFixed(2)}`, pageWidth - margin, y, { align: "right" });
    
        doc.text(`Due`, pageWidth - margin - 200, (y += 15));
        doc.text(`Rs ${due.toFixed(2)}`, pageWidth - margin, y, { align: "right" });
    
        // ---------- AMOUNT IN WORDS ----------
        y += 30;
        doc.text(`Amount in Words: ${numberToWords(grandTotal)}`, margin, y);
        y += 25; // 👈 small gap
        doc.setFont("helvetica", "bold");
        doc.text("Authorised Signature", pageWidth - margin, y, { align: "right" });
        // ---------- OPEN PDF ----------
        window.open(doc.output("bloburl"), "_blank");
    };
    

    const handlePrintInvoice = (item) => {
        generateInvoicePdf(item);
    };

    const handleViewMedicines = (row) => {
        setSelectedBillInfo(row);
        setSelectedBillMedicines(row.items || []);
        setShowMedicineModal(true);
    };

    const closeMedicineModal = () => {
        setShowMedicineModal(false);
        setSelectedBillMedicines([]);
        setSelectedBillInfo(null);
    };

    useEffect(() => {
        let totalAmount = 0,
            discountAmount = 0,
            paidAmount = 0,
            dueAmount = 0,
            totalTaxCharges = 0,
            totalGrossValue = 0;

        const toNum = (val) => {
            const num = parseFloat(val);
            return isNaN(num) ? 0 : num;
        };

        formData.l1.forEach((bill) => {
            totalAmount += toNum(bill.med_bill_total);
            discountAmount += toNum(bill.med_bill_discount_amt);
            paidAmount += toNum(bill.med_bill_paid);
            dueAmount += toNum(bill.med_bill_due);

            if (bill.items && bill.items.length > 0) {
                bill.items.forEach((med) => {
                    totalTaxCharges += toNum(med.med_bill_item_mrp) * toNum(med.med_bill_item_strips);
                    totalGrossValue += toNum(med.med_bill_item_mrp);
                });
            }
        });

        setTotals({
            totalAmount,
            discountAmount,
            paidAmount,
            dueAmount,
            totalTaxCharges,
            totalGrossValue,
        });
    }, [formData.l1]);

    // DataTable Columns
    const columns = [
        {
            name: 'Actions',
            width: '260px',
            cell: (row) => {
              const admin = isAdminUser();
              const due = parseFloat(row.med_bill_due || 0);
          
              return (
                <div className="d-flex gap-1">
          
                  {/* VIEW */}
                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => handleViewMedicines(row)}
                  >
                    <i className="ri-eye-line"></i>
                  </button>
          
                  {/* PRINT */}
                  <button
                    className="btn btn-sm btn-outline-info"
                    onClick={() => handlePrintInvoice(row)}
                  >
                    <i className="ri-printer-line"></i>
                  </button>
          
                  {/* PAY (ONLY IF DUE > 0) */}
                  {due > 0 && (
                    <button
                      className="btn btn-sm btn-outline-warning"
                      onClick={() => handlePay(row)}
                    >
                      Pay <i className="ri-money-rupee-circle-line"></i>
                    </button>
                  )}
          
                  {/* EDIT (ADMIN) */}
                  <button
                    className="btn btn-sm btn-outline-success"
                    disabled={!admin}
                    style={{ opacity: admin ? 1 : 0.5 }}
                    onClick={() => {
                      if (!admin) return Swal.fire("Only admin can edit");
                      sessionStorage.setItem("opd_dt", JSON.stringify(row));
                      navigate("/pharmacy_sale");
                    }}
                  >
                    <i className="ri-pencil-line"></i>
                  </button>
          
                  {/* DELETE (ADMIN) */}
                  <button
                    className="btn btn-sm btn-outline-danger"
                    disabled={!admin}
                    style={{ opacity: admin ? 1 : 0.5 }}
                    onClick={() => admin ? delItem(row) : Swal.fire("Only admin can delete")}
                  >
                    <i className="ri-delete-bin-line"></i>
                  </button>
          
                </div>
              );
            },
            ignoreRowClick: true,
            button: true
          },
          
          {
            name: 'Bill No',
            selector: row => row.med_bill_id,
            sortable: true,
            cell: row => formatBillNo(row.med_bill_id),
            width: '100px',
        },
        {
            name: 'Sr. No.',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '80px',
        },
        {
            name: 'UHID',
            selector: row => row.med_bill_ipd_number,
            sortable: true,
            wrap: true,
        },
        {
            name: 'Patient',
            selector: row => row.med_bill_patient_number,
            sortable: true,
            wrap: true,
        },
        {
            name: 'Referred Doctor',
            selector: row => row.med_bill_ref_doctor,
            sortable: true,
            wrap: true,
            width: '200px',
        },
        {
            name: 'Billing Date',
            selector: row => row.med_bill_date,
            sortable: true,
            cell: row => formatDate(row.med_bill_date),
            width: '200px',
        },
        {
            name: 'Discount',
            selector: row => row.med_bill_discount_amt || "0.00",
            sortable: true,
            cell: row => `₹${parseFloat(row.med_bill_discount_amt || 0).toFixed(2)}`
        },
        {
            name: 'Paid',
            selector: row => row.med_bill_paid,
            sortable: true,
            cell: row => `₹${parseFloat(row.med_bill_paid || 0).toFixed(2)}`
        },
        {
            name: 'Due',
            selector: row => row.med_bill_due,
            sortable: true,
            cell: row => `₹${parseFloat(row.med_bill_due || 0).toFixed(2)}`
        },
        {
            name: 'Total',
            selector: row => row.med_bill_final_amt,
            sortable: true,
            cell: row => `₹${parseFloat(row.med_bill_final_amt || 0).toFixed(2)}`
        },
        {
            name: 'Last Used',
            selector: row => row.user_display,
            sortable: true,
            cell: row => row.user_display || '-',
            width: '180px'
          },
          
          
     
    ];

    // Custom styles for DataTable
    const customStyles = {
        headRow: {
            style: {
                backgroundColor: '#f1f5fb',
                borderBottom: '2px solid #dee2e6',
                fontSize: '15px',
                fontWeight: '700',
                color: '#405189',
            },
        },
        headCells: {
            style: {
                paddingLeft: '14px',
                paddingRight: '14px',
            },
        },
        rows: {
            style: {
                fontSize: '16px',
                minHeight: '58px',
            },
        },
        cells: {
            style: {
                paddingLeft: '14px',
                paddingRight: '14px',
                fontSize: '15px',
                lineHeight: '55px'
            },
        },
    };

    return (
        <div className="page-content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card" id="orderList">
                            <div className="card-header border-0">
                                <div className="row align-items-center gy-3">
                                    <div className="col-sm">
                                        <h5 className="card-title mb-0">Sales</h5>
                                    </div>
                                    <div className="col-sm-auto">
                                        <div className="d-flex gap-1 flex-wrap">
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    sessionStorage.removeItem("opd_dt");
                                                    navigate("/pharmacy_sale");
                                                }}
                                                className="btn btn-success add-btn"
                                            >
                                                <i className="ri-add-line align-bottom me-1"></i> Add Sale
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card-body border border-dashed border-end-0 border-start-0">
                                <form>
                                    <div className="row g-3">
                                        <div className="col-md-3">
                                            <label className="form-label">From Date</label>
                                            <input
                                                className="form-control"
                                                type="date"
                                                name="from_date"
                                                onChange={handleChange}
                                                value={formData.from_date}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <label className="form-label">To Date</label>
                                            <input
                                                className="form-control"
                                                type="date"
                                                name="to_date"
                                                onChange={handleChange}
                                                value={formData.to_date}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <label className="form-label">Search</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                name="search_key"
                                                placeholder="Search..."
                                                onChange={handleChange}
                                                value={formData.search_key}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <label className="form-label">&nbsp;</label>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        search_key: "",
                                                        from_date: getTodayDate(),
                                                        to_date: getTodayDate(),
                                                    }));
                                                }}
                                                className="btn btn-info w-100"
                                            >
                                                <i className="ri-refresh-line me-1"></i> Clear
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            <div className="card-body pt-0">
                                <DataTable
                                    columns={columns}
                                    data={formData.l1}
                                    pagination
                                    paginationPerPage={10}
                                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                    highlightOnHover
                                    striped
                                    responsive
                                    customStyles={customStyles}
                                    noDataComponent={
                                        <div className="text-center py-5">
                                            <i className="ri-file-list-line fs-1 text-muted"></i>
                                            <p className="mt-3">No sales records found</p>
                                        </div>
                                    }
                                />

                                <div className="mt-3 p-3 bg-light rounded">
                                    <div className="row text-center">
                                        <div className="col-md-3">
                                            <strong>Total Amount:</strong>
                                            <div className="fs-5 text-primary">₹{totals.totalAmount.toFixed(2)}</div>
                                        </div>
                                        <div className="col-md-3">
                                            <strong>Paid Amount:</strong>
                                            <div className="fs-5 text-success">₹{totals.paidAmount.toFixed(2)}</div>
                                        </div>
                                        <div className="col-md-3">
                                            <strong>Due Amount:</strong>
                                            <div className="fs-5 text-danger">₹{totals.dueAmount.toFixed(2)}</div>
                                        </div>
                                        <div className="col-md-3">
                                            <strong>Total Discount:</strong>
                                            <div className="fs-5 text-info">₹{totals.discountAmount.toFixed(2)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Medicine Details Modal */}
            {showMedicineModal && (
                <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    <i className="ri-medicine-bottle-line me-2"></i>
                                    Medicine Details - {selectedBillInfo?.med_bill_ipd_number}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={closeMedicineModal}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3 p-3 bg-light rounded">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <strong>Patient:</strong> {selectedBillInfo?.med_bill_patient_number}
                                        </div>
                                        <div className="col-md-6">
                                            <strong>Date:</strong> {formatDate(selectedBillInfo?.med_bill_date)}
                                        </div>
                                    </div>
                                </div>

                                <div className="table-responsive">
    <table className="table table-bordered table-hover">
        <thead className="table-light">
            <tr>
                <th>Sr.</th>
                <th>Medicine Name</th>
                <th>Pack</th> {/* ✅ Added Pack column */}
                <th>Batch</th>
                <th>Qty</th>
                <th>MRP</th>
                <th>Discount</th>
                <th>Total</th>
            </tr>
        </thead>
        <tbody>
            {selectedBillMedicines.length > 0 ? (
                selectedBillMedicines.map((med, index) => (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{med.med_bill_item_medicine}</td>
                        {/* ✅ Show Loose or Package */}
                        <td>
                            {(med.med_bill_item_is_loose === "1" || med.med_bill_item_is_loose === 1) 
                                ? "Loose" 
                                : "Package"}
                        </td>
                        <td>{med.med_bill_item_batch}</td>
                        <td>{med.med_bill_item_qty}</td>
                        <td>₹{parseFloat(med.med_bill_item_mrp || 0).toFixed(2)}</td>
                        <td>₹{parseFloat(med.med_bill_item_discount || 0).toFixed(2)}</td>
                        <td>₹{parseFloat(med.med_bill_item_total || 0).toFixed(2)}</td>
                    </tr>
                ))
            ) : (
                <tr>
                    <td colSpan="8" className="text-center">No medicines found</td>
                </tr>
            )}
        </tbody>
        {selectedBillMedicines.length > 0 && (
            <tfoot className="table-light">
                <tr>
                    <td colSpan="7" className="text-end"><strong>Total:</strong></td>
                    <td>
                        <strong>
                            ₹{selectedBillMedicines.reduce((sum, med) => 
                                sum + parseFloat(med.med_bill_item_total || 0), 0
                            ).toFixed(2)}
                        </strong>
                    </td>
                </tr>
            </tfoot>
        )}
    </table>
</div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={closeMedicineModal}
                                >
                                    Close
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => handlePrintInvoice(selectedBillInfo)}
                                >
                                    <i className="ri-print-fill me-1"></i> Print Invoice
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Sales;